import { createSlice } from '@reduxjs/toolkit';

import type { IError } from '../../../types/IApiTypes';

const initialState: IError = {
  code: '',
  message: '',
  page: '',
  data: null,
  show: true,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError(state, action) {
      return action.payload;
    },
    resetError() {
      return initialState;
    },
  },
});

export const { setError, resetError } = errorSlice.actions;

export default errorSlice.reducer;
